import classNames from 'classnames'
import React from 'react'
import { Form } from 'react-bootstrap'

import './text-field.css'

const TextField = (props) => {
  const { data = [], value, showblank, onChange, errorText, isInvalid, icon, onIconClick, ...restProps } = props
  const newData = data.filter(el => {
    return el.toLowerCase().includes(value.toLowerCase())
  });
  const isInputActive = (showblank || !!(value || '').length) && !data.find(el => el === value)
  const activeInputData = isInputActive && !!data.length && (
    <div className='text-field__search-list'>
      <ul>
        {newData.map((el, i) => (
          value !== el
            ? (
              <li
                key={i}
                onClick={() => {
                  const newValue = { target: { value: el } }
                  onChange(newValue)
                }}
              >
                {el}
              </li>
            )
            : ''
        ))}

      </ul>
    </div>
  )
  const errorClasses = classNames('text-field__error', {
    'text-field__error--with-label': props.label
  })

  return props.label
    ? (
        <div className='text-field__container flex-container--column'>
          <Form.Label>{props.label}</Form.Label>
          <Form.Control type='text' className='text-field' {...{ value, onChange, ...restProps }} />
          {activeInputData}
          {isInvalid && (
            <div className={errorClasses}>
              {errorText}
            </div>
          )}
        </div>
      )
    : (
      <div className='text-field__container'>
        <>
        <Form.Control
          type='text'
          className='text-field'
          {...{ value, onChange, ...restProps }}
        />
        {icon && (
          <img
            className='text-field__search-icon'
            src={icon}
            onClick={onIconClick}
            alt='search-icon'
          />
        )}
        {activeInputData}
        {isInvalid && (
          <div className={errorClasses}>
            {errorText}
          </div>
        )}
        </>
      </div>
    )
}

export default TextField
